import { useQuery } from "@apollo/client";
import { forwardRef } from "react";
import { SEMINAR_TYPE_MANY } from "../../../schema/seminarType";
import { SeminarType } from "../../../types";

import { Error, Loading } from "../../ui/Alerts";

const SeminarTypeSelect = forwardRef((props: any, ref: any) => {
  const { loading, error, data } = useQuery(SEMINAR_TYPE_MANY);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  return (
    <select
      {...props}
      ref={ref}
      autoComplete="type"
      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
    >
      <option value=""></option>
      {data.seminarTypeMany.map((seminarType: SeminarType) => (
        <option key={seminarType._id} value={seminarType._id}>
          {seminarType.name}
        </option>
      ))}
    </select>
  );
});

export default SeminarTypeSelect;
